<template>
  <div class="terms-page">
    <b-container class="py-5">
      <h1 class="mb-4 text-center">{{ $t('terms.title') }}</h1>
      <p class="text-center text-muted mb-5">{{ $t('terms.last_updated') }}</p>
      
      <div class="content shadow-sm p-4 bg-white rounded">
        <p>{{ $t('terms.intro_1') }}</p>
        <p>{{ $t('terms.intro_2') }}</p>
        <p>{{ $t('terms.intro_3') }}</p>

        <h3 class="mt-4">{{ $t('terms.accounts_title') }}</h3>
        <p>{{ $t('terms.accounts_desc_1') }}</p>
        <p>{{ $t('terms.accounts_desc_2') }}</p>
        <p>{{ $t('terms.accounts_desc_3') }}</p>

        <h3 class="mt-4">{{ $t('terms.rewards_title') }}</h3>
        
        <h5 class="mt-3">{{ $t('terms.earning_title') }}</h5>
        <p>{{ $t('terms.earning_desc') }}</p>

        <h5 class="mt-3">{{ $t('terms.exclusions_title') }}</h5>
        <p>{{ $t('terms.exclusions_desc') }}</p>

        <h5 class="mt-3">{{ $t('terms.payments_title') }}</h5>
        <p>{{ $t('terms.payments_desc') }}</p>

        <h5 class="mt-3">{{ $t('terms.returns_title') }}</h5>
        <p>{{ $t('terms.returns_desc') }}</p>
        <ul>
            <li>{{ $t('terms.returns_list_1') }}</li>
            <li>{{ $t('terms.returns_list_2') }}</li>
        </ul>

        <h3 class="mt-4">{{ $t('terms.intellectual_title') }}</h3>
        <p>{{ $t('terms.intellectual_desc') }}</p>

        <h3 class="mt-4">{{ $t('terms.links_title') }}</h3>
        <p>{{ $t('terms.links_desc_1') }}</p>
        <p>{{ $t('terms.links_desc_2') }}</p>

        <h3 class="mt-4">{{ $t('terms.termination_title') }}</h3>
        <p>{{ $t('terms.termination_desc') }}</p>

        <h3 class="mt-4">{{ $t('terms.liability_title') }}</h3>
        <p>{{ $t('terms.liability_desc') }}</p>

        <h3 class="mt-4">{{ $t('terms.disclaimer_title') }}</h3>
        <p>{{ $t('terms.disclaimer_desc') }}</p>

        <h3 class="mt-4">{{ $t('terms.governing_law_title') }}</h3>
        <p>{{ $t('terms.governing_law_desc') }}</p>

        <h3 class="mt-4">{{ $t('terms.changes_title') }}</h3>
        <p>{{ $t('terms.changes_desc') }}</p>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style scoped>
.content {
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
}
h3 {
    font-size: 1.25rem;
    font-weight: bold;
    color: #2c3e50;
}
h5 {
    font-size: 1.1rem;
    font-weight: 600;
    color: #34495e;
}
</style>
